import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import Store from './store/Store';

Vue.config.productionTip = false;

Vue.use(Vuex);

const store = new Vuex.Store(Store);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store: store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js